import React, { useEffect } from 'react';

import i18n from 'i18n-js';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import useStyles from './Connections.styled';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import BrokersConnection from 'components/BrokersConnection';
import { OrganizationsActions } from 'state/modules/organizations';

const VehicleConnections = ({ currentVehicle, showLabel = true }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { errors } = useSelector((state) => state.vehicles);
  const { fetchingAvailablesBrokers, availablesBrokers, loading } = useSelector(
    (state) => state.organizations
  );

  const addBrokerToVehicle = (payload, action) => {
    dispatch(vehicleActions.fetchAddBroker(currentVehicle.id, payload, action));
  };

  const removeBroker = (value) => {
    dispatch(vehicleActions.fetchRemoveBroker(currentVehicle?.id, value?.broker_slug));
  };

  useEffect(() => {
    dispatch(OrganizationsActions.fetchAvailablesBrokers({ class_slug: 'VH' }));
  }, [dispatch]);

  return (
    <Box className={classes.container}>
      <Container className="h-100" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography gutterBottom component="div" align="left">
              <Box fontWeight="500" fontSize={14} pr={4} mt={2} mb={4}>
                {showLabel ? i18n.t('vehicle.select_broker') : ''}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <BrokersConnection
              availables={{
                list: [...availablesBrokers],
                loading: fetchingAvailablesBrokers,
              }}
              errors={errors}
              loading={loading}
              onRemoveBroker={removeBroker}
              onAddBroker={addBrokerToVehicle}
              assigned={currentVehicle?.brokers || {}}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default VehicleConnections;
